
import { defineComponent } from "vue";

import { postSamplingPointStation } from "@/service/samplingpointstation.service";
import { SamplingPointStation } from "@/types/samplingPointStation.type";
import { Station } from "@/types/station.type";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";

export default defineComponent({
  components: {},
  props: {
    listSamplingPoints: {
      type: Object as () => SamplingPointStation[],
      required: false,
    },
  },
  setup() {
    const store = useStore<RootState>();
    return { store };
  },
  data() {
    return {
      stationsSelects: [] as Station[],
    };
  },
  computed: {
    stations(): Station[] {
      return this.store.state.station.stations;
    },
  },
  mounted() {
    this.store.dispatch("station/addStationsSelects");
  },

  methods: {
    getStations() {
      this.store.dispatch("station/addStationsSelects");

      return this.store.getters["station/getStations"];
    },

    async saveChanges(item: SamplingPointStation) {
      await postSamplingPointStation(item).then(async () => {
        this.stations = await this.getStations();
      });
    },
  },
});
